// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"c508b54b","420":"5946286a","594":"161bc4d6","685":"8fc3685e","788":"4d6038bd"}[chunkId] + ".chunk.css";
};